import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import { addRedirectURI } from "../../apis/postProvisionApi/postProvisionApi";

type RedirectURIConfigProps = {
  clientId: any;
  onComplete?: () => void;
};

interface RedirectURIData {
  success: boolean;
  error?: string;
}


const RedirectURIConfig = ({ onComplete, clientId }: RedirectURIConfigProps) => {
  const [redirectURI, setRedirectURI] = useState("");
  const [appRegistrationId, setAppRegistrationId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!redirectURI.trim() || !appRegistrationId.trim()) {
      setError("Both Redirect URI and App Registration ID are required");
      return;
    }
    setError("");
    setLoading(true);

    addRedirectURI(
      {
        redirectURI,
        appRegistrationId,
        clientId,
      },
      (data: RedirectURIData) => {
        setLoading(false);

        if (!data || data.success === false) {
          setError(data?.error || "Update failed");
          return;
        }
        setRedirectURI("");
        setAppRegistrationId("");

        if (typeof onComplete === "function") {
          onComplete();
        }
      }
    );
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        OAuth Redirect URI Configuration
      </Typography>

      <TextField
        label="Redirect URI"
        value={redirectURI}
        onChange={(e) => setRedirectURI(e.target.value)}
        fullWidth
        sx={{ my: 2 }}
        placeholder="https://yourapp.com/callback"
      />

      <TextField
        label="App Registration ID"
        value={appRegistrationId}
        onChange={(e) => setAppRegistrationId(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
        placeholder="Enter your App Registration ID"
      />
      <Button variant="contained" disabled={loading} onClick={handleSave}>
        {loading ? <CircularProgress size={20} /> : "Save Redirect URI"}
      </Button>
    </Box>
  );
};

export default RedirectURIConfig;
